import React, {useState} from 'react';
import {useTheme} from '@material-ui/core';
import RateDesktop from './RateDesktop';
import RateMobile from './RateMobile';
import RateCompleteGood from './RateCompleteGood';
import RateComplete from './RateComplete';

/**
 * Base rate component
 * @param question
 */
const RateBase = ({question}:
                      {
                        question: string,
                      }) => {

  const [rated, setRated] = useState(0);
  const theme = useTheme();
  const isScreenSmall = window.innerWidth < theme.breakpoints.values.md;

  // show mobile variant
  if (!rated && isScreenSmall) {
    return <RateMobile {...{
      question,
      rated: (val: number) => setRated(val),
    }}/>;

  // show desktop variant
  } else if (!rated) {
    return <RateDesktop {...{
      question, rated: (val: number) => setRated(val),
    }}/>;

  } else if (rated > 8) {
    return <RateCompleteGood/>;

  } else {
    return <RateComplete/>;
  }
};

export default RateBase;
